import {HTMLAttributes} from 'react';

type YandexIconProps = HTMLAttributes<SVGSVGElement>;

export const YandexIcon = (props: YandexIconProps) => {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      version="1.1"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 12C1 5.9247 5.9236 1 12 1C18.0742 1 23 5.9247 23 12C23 18.0753 18.0742 23 12 23C5.9236 23 1 18.0753 1 12Z"
        fill="#FC3F1D"
      />
      <path
        d="M13.4081 7.23266H12.3917C10.5283 7.23266 9.54822 8.17646 9.54822 9.56796C9.54822 11.141 10.2258 11.878 11.6173 12.8229L12.7668 13.5973L9.46352 18.533H6.99512L9.95962 14.1176C8.25462 12.8955 7.29762 11.7086 7.29762 9.70106C7.29762 7.18426 9.05212 5.46606 12.3796 5.46606H15.6829V18.5209H13.4081V7.23266Z"
        fill="white"
      />
    </svg>
  );
};
